// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__2yEY1","title":"ClientReferral_title__5_x6E","itemText":"ClientReferral_itemText__3cg6B"};